import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Input,
  Button,
  Row,
  Col,
  Modal,
  Form,
  Popconfirm,
  message
} from "antd";
import axios from "axios";

const ManagePosition = () => {
  const [positions, setPositions] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingPosition, setEditingPosition] = useState(null);

  const [form] = Form.useForm();
  const token = localStorage.getItem("access-token");

  // ================= FETCH =================
  const fetchPositions = () => {
    axios
      .get("http://localhost:5000/api/positions", {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then((res) => setPositions(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    fetchPositions();
  }, []);

  // ================= UPDATE =================
  const handleSave = () => {
    form.validateFields().then((values) => {
      axios
        .put(
          `http://localhost:5000/api/positions/${editingPosition._id}`,
          values,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then(() => {
          message.success("Position Updated");
          closeModal();
        });
    });
  };

  // ================= DELETE =================
  const handleDelete = (id) => {
    axios
      .delete(`http://localhost:5000/api/positions/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(() => {
        message.success("Position Deleted");
        fetchPositions();
      });
  };

  // ================= EDIT =================
  const handleEdit = (record) => {
    setEditingPosition(record);
    form.setFieldsValue(record);
    setIsModalOpen(true);
  };

  // ================= CLOSE =================
  const closeModal = () => {
    setIsModalOpen(false);
    setEditingPosition(null);
    form.resetFields();
    fetchPositions();
  };

  // ================= SEARCH =================
  const filteredData = positions.filter((item) =>
    item.position.toLowerCase().includes(searchText.toLowerCase())
  );

  // ================= TABLE =================
  const columns = [
    {
      title: "SL",
      render: (_, __, index) => index + 1
    },
    {
      title: "Position",
      dataIndex: "position"
    },
    {
      title: "Details",
      dataIndex: "details"
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => handleEdit(record)}>
            Edit
          </Button>

          <Popconfirm
            title="Are you sure delete?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      )
    }
  ];

  return (
    <Card title="Manage Position">
      <Row justify="space-between" style={{ marginBottom: 16 }}>
        <Col>
          <Input
            placeholder="Search Position"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: 200 }}
          />
        </Col>
      </Row>

      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
      />

      {/* EDIT MODAL */}
      <Modal
        title="Edit Position"
        open={isModalOpen}
        onCancel={closeModal}
        onOk={handleSave}
        okText="Update"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Position"
            name="position"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Details" name="details">
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

export default ManagePosition;